<template>
  <div
    class="bg-base-300 relative flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10"
  >
    <div class="w-full max-w-md space-y-4">
      <LoginAlert :reason="reason" />
      <div class="bg-base-100 w-full rounded-xl p-8 shadow-lg">
        <div class="flex flex-col items-center gap-4">
          <div class="h-16 py-1 text-center">
            <Icon name="mgd:midland" class="text-primary size-full" />
          </div>
          <h1 class="sr-only">Midland Garage Door - Dealer Portal</h1>
          <MgdButton type="submit" class="w-full" as-child>
            <NuxtLink
              :to="{ path: '/_auth/login', query: { redirect } }"
              external
            >
              Login
            </NuxtLink>
          </MgdButton>
          <MgdSeparator class="my-4" label="Or" />
          <MgdButton
            type="submit"
            class="w-full"
            variant="ghost"
            size="sm"
            as-child
          >
            <NuxtLink to="/_auth/login?midlandEmployee=true" external
              >Midland Employee Login</NuxtLink
            >
          </MgdButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { parseApiErrorCode } from "~~/shared/api/errors";

definePageMeta({
  layout: false,
  public: true,
  middleware: [
    () => {
      const { loggedIn } = useAppSession();
      if (loggedIn.value) {
        return navigateTo("/");
      }
    },
  ],
});
useHead({ title: "Login" });
const route = useRoute();
const reason = computed(() => parseApiErrorCode(route.query.reason));

const redirect = computed(() =>
  typeof route.query.redirect === "string" ? route.query.redirect : undefined,
);
</script>
